/* global Swiper */

// **********************************************************
// Small slider
// **********************************************************
const valuesSwiperElements = document.querySelectorAll('[data-slider="values-slider"]');

valuesSwiperElements.forEach((el) => {
  const valuesSwiperOptions = {
    speed: 300,
    watchOverflow: true,
    autoHeight: true,
    slidesPerView: 'auto',
    spaceBetween: 8,
    loop: true,
    centeredSlides: true,
    pagination: {
      el: '.values-pagination',
    },
    breakpoints: {
      577: {
        slidesPerView: 3,
        loop: true,
        centeredSlides: true,
      },
      1141: {
        slidesPerView: 5,
        spaceBetween: 30,
        loop: false,
        centeredSlides: false,
      },
    },
  };
  // eslint-disable-next-line no-unused-vars
  const valuesSwiper = new Swiper(el, valuesSwiperOptions);
});
